function Facturacion() {
  return (
    <div>
      <h1>Facturación</h1>
      <p>Aquí irá el módulo de facturación</p>
    </div>
  );
}

export default Facturacion;